import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();
